import React from "react";
import {Columns, Heading, Modal, Section, Table} from "react-bulma-components";


export default function InfoModal({show, setShow}){



    return (
        <Modal
            show={show}
            closeOnBlur
            onClose={()=> setShow(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Info</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Table bordered>
                                <tr>
                                    <td className={"table-highlight-red"}></td>
                                    <td>If the quote has only finished jobs and not started jobs</td>
                                </tr>
                                <tr>
                                    <td className={"table-highlight-green"}></td>
                                    <td>If the quote is ready for approval (all work items and parts have workshop invoice numbers) and all jobs are approved</td>
                                </tr>
                                <tr>
                                    <td className={"table-highlight-orange"}></td>
                                    <td>If the quote has a job and does not meet any of the other conditions above</td>
                                </tr>
                            </Table>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )

}